import React, { useState } from "react";
import { Container, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list";
import * as OrganizationQL from "queries/organization";
import * as Section from "@repoflow/components/section";
import { SearchBox, SearchResults } from "./search";

export const Sidebar = () => null;

// The section that owns this page draws the "Organizations" crumb, so there is
// nothing left for the list itself to add.
export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base, schema } = Section.useSectionContext();

  // null = not searching, so the ordinary paged list shows. An empty array is a
  // search that matched nothing, which is a different thing.
  const [results, setResults] = useState(null);

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col md={4}>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add Organization
          </Link>
        </Col>
        <Col md={8}>
          <SearchBox domain={params.domain} onResults={setResults} />
        </Col>
      </Row>

      <div className="mt-4"></div>

      {results !== null ? <SearchResults items={results} /> : <List
        path={"viewer.account.domains.get.organizations"}
        query={OrganizationQL.list}
        variables={params}
        schema={schema}
        target={{ $ref: "/Public/Organization" }}
        empty={"No organizations yet."}
        config={{
          "/Public/Organization": {
            fields: ["description", "orgId", "createdAt"],
          },
        }}
        content={({ item: { orgId } }) => (
          <Link className={"btn btn-primary"} to={`${base}/${orgId}`}>
            View
          </Link>
        )}
      />}
    </Container>
  );
};
